<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div
          class="col d-flex align-items-center"
          style="padding: 0%;"
        >
          <b-link
            :to="{ name: 'adminTreinamentos' }"
            class="font-weight-bold d-block text-nowrap mr-3 mb-2"
          >
            <el-button
              style="border: none; background-color: transparent;"
              type="button"
              class="is-plain"
              @click="limparStorage"
            >
              <i class="el-icon-back" />
              Editar conteudo
            </el-button>
          </b-link>
        </div>
        <b-card-code
          title="Título"
          :style="{width: '582.2px', boxSizing: 'border-box' }"
        >
          <div class="col">
            <b-form-input
              id="add-titulo-conteudo"
              v-model="params.conteudo_titulo"
              type="text"
              debounce="500"
            />
          </div>
          <div class="divider" />
          <div class="row">
            <div class="col">
              <div class="divider" />
              <div class="col-md-4">
                <b-form-group class="mb-0">
                  <b-form-input
                    id="pesq-video-conteudo"
                    v-model="selectedOption"
                    list="my-list-id"
                    placeholder="Pesquisar Video"
                    @input="onSearch(selectedOption)"
                  />
                  <datalist id="my-list-id">
                    <option
                      v-for="size in options"
                      :key="size.id"
                      :label="size.vsl_name"
                      :value="size.vsl_name"
                    >
                      {{ size.vsl_name }}
                    </option>
                  </datalist>
                </b-form-group>
              </div>

              <b-card-code
                title="Video"
                :style="{ minWidth: 'calc(582.2px / 3)', boxSizing: 'border-box' }"
              >
                <div>
                  <b-embed
                    type="iframe"
                    aspect="16by9"
                    :src="selectedValue"
                    allowfullscreen
                  />
                </div>
              </b-card-code>
            </div>
          </div>
        </b-card-code>
      </div>
      <div class="col">
        <div class="col d-flex justify-content-end align-items-center">
          <div class="mr-3 mb-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="CreateConteudo()"
            >
              Salvar Conteudo
            </b-button>
          </div>
        </div>
        <b-card
          id="editor-texto-conteudo"
          :style="{ width: '582.2px', height: '500px' }"
        >
          <b-card-code
            title="Editor de conteúdo"
            :style="{ boxSizing: 'border-box', height: '100%' }"
          >
            <quill-editor
              v-model="params.conteudo_content"
              :options="snowOption"
              :style="{ height: '70%' }"
            />
          </b-card-code>
        </b-card>
        <b-card
          id="anexo-arquivos-conteudo"
          class="custom-card align-items-center justify-content-center"
        >
          <b-card-code title="Você pode anexar arquivos">
            <el-upload
              class="upload-demo"
              drag
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              multiple
              :file-list="list"
              :before-upload="handleChange"
            >
              <i class="el-icon-upload" />
              <div class="el-upload__text">
                Drop file here or <em>selecione do computador</em>
              </div>
              <div
                slot="tip"
                class="el-upload__tip"
              />
            </el-upload>
          </b-card-code>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import {
  BFormInput, BCardText, BFormTextarea, BEmbed,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { quillEditor } from 'vue-quill-editor'

import ConteudoService from '@/services/Conteudo'
// eslint-disable-next-line import/no-cycle
import router from '@/router'
import { UploadFilesService } from '@/services/UploadFiles'
import { useApi } from '@/composables/useApi'
import axios from 'axios'

const api = useApi()
const conteudoService = new ConteudoService()

export default {
  name: 'CriarconteDo',
  components: {
    quillEditor,
    BCardCode,
    BFormInput,
    BCardText,
    BFormTextarea,
    BEmbed,

  },
  data() {
    return {
      list: [],
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      selectedValue: '',
      searchQuery: '',
      selectedOption: '',
      options: [],
      valueTextearea: '',
      valueTitulo: '',
      snowOption: {
        theme: 'snow',
      },
      content: '',
      params: {
        conteudo_titulo: '',
        modulo_id: '',
        conteudo_content: '',
        conteudo_files: '',
        conteudo_video_url: '',
        id_vsl: '',
      },
      paramsFiles: {
        id_conteudo: '',
        file_name: '',
        file_bucket_address: '',
        file_key_name: '',
        file_type: '',
        id_user: '',
        file_uid: '',
      },
    }
  },
  computed: {
    selectedUrl() {
      // find the object that matches the selected option
      const option = this.options.find(option => option.vsl_name === this.selectedOption)
      // return its url or an empty string if not found
      return option ? option.vsl_bucket_address : ''
    },

    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
  },
  mounted() {
    this.getvsls()
    this.getvslsId()
    this.getConteudoById()
  },
  methods: {
    async CreateConteudo() {
      const id = localStorage.getItem('idConteudo')
      await conteudoService.UpdatConteudo(id, this.params).then(() => {
        localStorage.removeItem('idConteudo')
        localStorage.removeItem('uidConteudo')
        this.$notify({
          title: 'Sucesso',
          message: 'Conteúdo Editado com sucesso',
          type: 'success',
        })
        router.push({ name: 'adminTreinamentos' })
      })
    },
    async getConteudoById() {
      // const { id } = router.currentRoute.params
      const id = localStorage.getItem('idConteudo')

      await conteudoService.ConteudoById(id).then(response => {
        console.log('response', response)
        this.params.conteudo_titulo = response.conteudo_titulo
        this.params.conteudo_content = response.conteudo_content
        this.params.conteudo_video_url = response.conteudo_video_url
        this.params.conteudo_sequencia = response.conteudo_sequencia
        this.params.modulo_id = response.modulo_id
        this.selectedValue = response.conteudo_video_url
        this.params.id_vsl = response.id_vsl
      })
      await this.getFilesList()
    },
    onSearch(searchQuery) {
      const selectedObject = this.options.find(
        option => option.vsl_name === searchQuery,
      )
      if (selectedObject) {
        this.params.id_vsl = selectedObject.id
      }

      this.searchQuery = searchQuery
      this.selectedValue = this.selectedUrl
      this.params.conteudo_video_url = this.selectedUrl
      this.getvsls()
    },
    async getvsls() {
      await api.get(`/getVslUserById?id_user=${this.getUserData.id}&vsl_name=${this.searchQuery}`)
        .then(response => {
          this.options = response.data
        })
    },

    async getvslsId() {
      await api.get(`vslUserId/${this.getUserData.id}`)
        .then(response => {
          this.options = response.data
        })
    },

    // handlePreview(file) {
    //   console.log('Arquivo pré-visualizado:', file)
    // },
    async handleRemove(file) {
      const uploadFilesService = new UploadFilesService()
      await uploadFilesService.delefile(file.uuid)

      const index = this.list.findIndex(item => item.uuid === file.uuid)
      if (index !== -1) {
        this.list.splice(index, 1)
        console.log(`O item com uuid ${file.uuid} foi removido da lista.`)
      } else {
        console.log(`O item com uuid ${file.uuid} não existe na lista.`)
      }
    },
    handleChange(file) {
      console.log(file)
      this.handleUpload(file, file.uid)
    },
    async handleUpload(file, uid) {
      const formData = new FormData()
      const caminho = `${this.getUserData.user_file_key}Upload_Files/`
      formData.append('file', file)
      formData.append('caminho', caminho)
      await axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/UploadArquivos`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
        this.paramsFiles = {
          id_conteudo: localStorage.getItem('uidConteudo'),
          file_name: response.data.data.fileNameOrigin,
          file_bucket_address: response.data.data.fileUrl,
          file_key_name: response.data.data.key_filename,
          file_type: response.data.data.file_type,
          id_user: this.getUserData.id,
          file_uid: uid,
        }
        const obj = {
          name: response.data.data.fileNameOrigin,
          url: response.data.data.fileUrl,
          uuid: uid,
        }

        this.list.push(obj)
      })
      const uploadFilesService = new UploadFilesService()
      await uploadFilesService.uploadfile(this.paramsFiles).then(() => {
      })
    },
    forceFileDownload(response, fileName) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    handlePreview(file) {
      console.log('file', file.name)
      axios({
        method: 'get',
        url: file.url,
        responseType: 'arraybuffer',
      })
        .then(response => {
          this.forceFileDownload(response, file.name)
        })
        .catch(() => console.log('error occured'))
    },
    async getFilesList() {
      await conteudoService.FileConteudoById(localStorage.getItem('uidConteudo'))
        .then(response => {
          this.list = response
        })
    },

    limparStorage() {
      localStorage.removeItem('idConteudo')
      localStorage.removeItem('uidConteudo')
    },
  },

}
</script>

<style scoped>
.custom-card {
  width: 582.2px;
  height: 399px;
}
</style>
